module.exports = __webpack_public_path__ + "static/img/lost.a0218b3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/lost.svg
// module id = LO6w
// module chunks = 4